import React from "react";
import AddTable from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/AddTable";
import Image from "react-bootstrap/Image";
export const SeatingDashboardDesktopTableHead = ({
  displayGridProps,
  parent,
  pathname,
  sortByDateTime,
}) => {
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          {displayGridProps ? null : (
            <th className="request-number">
              {parent === "events" ? null : (
                <p className="font_16_r">Request Type</p>
              )}
            </th>
          )}
          <th
            className="total-pax"
            style={{ width: displayGridProps ? "33%" : "" }}
          >
            <p className="font_16_r">
              Name /<br />
              Request Number/<br />
              Cross Reference ID
            </p>
          </th>
          <th className={displayGridProps ? "location-table" : "location"}>
            <p className="font_16_r">Total PAX</p>
          </th>
          <th
            // style={{ display: "flex", paddingLeft: "30px" }}
            style={{ width: "120px" }}
            className="d-flex align-items-center"
          >
            <div>
              <p className="font_16_r">Date / Time</p>
              {displayGridProps ? null : <p className="font_16_r">Timer</p>}
              {displayGridProps ? null : (
                <p className="font_10_r">(HH:MM:SS)</p>
              )}
            </div>
            <div
              className="ml-2"
              style={{ cursor: "pointer" }}
              onClick={() => (sortByDateTime ? sortByDateTime() : {})}
            >
              <Image
                alt="Sort"
                title="Sort"
                width="20px"
                src={require("../../../../assets/images/iconButton/ntimer.png")}
              />
            </div>
          </th>
          {displayGridProps ? null : (
            <th className="seating-preference" style={{ paddingLeft: "4rem" }}>
              <p className="font_16_r">
                Seating
                <br />
                Preference
              </p>
            </th>
          )}
          {displayGridProps ? null : (
            <th className="seating-preference">
              <p className="font_16_r">
                Total
                <br />
                Wait Time
              </p>
            </th>
          )}
          {displayGridProps ? null : (
            <th className="action pl-4">
              <p className="font_16_r">Actions</p>
            </th>
          )}
        </tr>
      </thead>
    </React.Fragment>
  );
};

export const SeatingDashboardTableManagement = () => {
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          <th>
            <p className="font_16_m">Table Management</p>
          </th>
          <th>
            <AddTable />
          </th>
        </tr>
      </thead>
    </React.Fragment>
  );
};
